import { PANELS as PANELS_DATA } from "./panels";
import { SCREENS as SCREENS_DATA } from "./screens";
import { SETTINGS as SETTINGS_DATA } from "./settings";
import type { PanelEntry, ScreenEntry, ScreenId, SettingEntry, SettingKind } from "./types";

export const SCREENS: readonly ScreenEntry[] = SCREENS_DATA;
export const SETTINGS: readonly SettingEntry[] = SETTINGS_DATA;
export const PANELS: readonly PanelEntry[] = PANELS_DATA;
export type { PanelEntry, Risk, ScreenEntry, ScreenId, SettingEntry, SettingKind } from "./types";

export function settingsFor(screen: ScreenId): SettingEntry[] {
  return SETTINGS.filter((s) => s.screen === screen);
}

export function panelsFor(screen: ScreenId): PanelEntry[] {
  return PANELS.filter((p) => p.screen === screen);
}

export function findSetting(kind: SettingKind, key: string): SettingEntry | undefined {
  return SETTINGS.find((s) => s.kind === kind && s.key === key);
}

export type CatalogHit =
  | { entry: SettingEntry; screen: ScreenId }
  | { entry: PanelEntry; screen: ScreenId };

/** Case-insensitive search over name, description and key (settings) / id (panels). */
export function searchCatalog(query: string): CatalogHit[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const hit = (...fields: string[]) => fields.some((f) => f.toLowerCase().includes(q));
  return [
    ...SETTINGS.filter((s) => hit(s.name, s.description, s.key)).map((entry) => ({
      entry,
      screen: entry.screen,
    })),
    ...PANELS.filter((p) => hit(p.name, p.description, p.id)).map((entry) => ({
      entry,
      screen: entry.screen,
    })),
  ];
}
